var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "#16BAB6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5007 8.9165V7.08317H19.1673V8.9165H15.5007ZM16.6006 15.3332L13.6673 13.1332L14.7673 11.6665L17.7006 13.8665L16.6006 15.3332ZM14.7673 4.33317L13.6673 2.8665L16.6006 0.666504L17.7006 2.13317L14.7673 4.33317ZM3.58398 14.4165V10.7498H2.66732C2.16315 10.7498 1.73155 10.5703 1.37253 10.2113C1.0135 9.85227 0.833984 9.42067 0.833984 8.9165V7.08317C0.833984 6.579 1.0135 6.14741 1.37253 5.78838C1.73155 5.42935 2.16315 5.24984 2.66732 5.24984H6.33398L10.9173 2.49984V13.4998L6.33398 10.7498H5.41732V14.4165H3.58398ZM9.08398 10.2457V5.754L6.83815 7.08317H2.66732V8.9165H6.83815L9.08398 10.2457ZM11.834 11.0707V4.929C12.2465 5.29567 12.5788 5.74255 12.8309 6.26963C13.0829 6.79671 13.209 7.37345 13.209 7.99984C13.209 8.62623 13.0829 9.20296 12.8309 9.73005C12.5788 10.2571 12.2465 10.704 11.834 11.0707Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/icon_live.136480d9.svg";
export { ForwardRef as ReactComponent };